
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(4(14|79|82)|5(13|18|79)|6(50|55|98)|021|13|790|811|826|914)|2(84[02]|(09|1|55|94)0|133|332|374|426|619|638)|5(96[36]|1(83|94|98)|3(09|78|79)|6(26|37|4|91)|098|282|525|583)|6(3(|8|9)8|(13|42|95)0|(09|53|78)8|(12|52|73)2|419)|1(7(15|33|89)|275|355|636|657)|8(02[56]|9(26|86|92)|154|180|206|430|602|63|748)|7((3|47|91)8|(20|65|79)3|(40|63|80)2|195|531|547)|3(44[23]|27[08]|9(2|34|43)|(72|78|88)1|106|154|342|37|535|63|697|876)|9(258|34|389|446|457|614|786|9|900))$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
